// client/src/features/banking/search.ts — SCR-BANK-001's URL state · BANK-004 (04 §9.2.3).
//
// §9.2.3 is NORMATIVE for every LIST screen: pagination and sort live in the URL as
// Zod-validated search params, so page 3 of the history survives a refresh and Back undoes the
// step that got there. `features/tenants/search.ts` is the shape this copies.
//
// There are no FILTERS, and that is D-233 rather than an omission. The filters a bank-import
// list would carry — by bank, by profile, by parse status, by whether anything was reconciled —
// are all facts about a statement that was READ, and V1 reads none. Four of
// `BankImportStatus`'s five members are unreachable, so a status filter would offer three empty
// options and one that matches every row. The list is what one organization has uploaded, newest
// first.

import { z } from 'zod';

/**
 * Newest first. The upload the user just made is the one they want to see confirmed, and
 * `uploadedAtUtc` is one of the three fields the endpoint declares sortable — the others being
 * `originalFileName` and `sizeBytes`, which no control offers yet and which a shared URL can
 * still carry.
 */
export const DEFAULT_SORT = 'uploadedAtUtc:desc';

/** 02 §7.4 — `pageSize` default 25, max 200; the server refuses more rather than clamping. */
export const bankImportSearchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(25),
  sort: z.string().default(DEFAULT_SORT),
});

export type BankImportSearch = z.infer<typeof bankImportSearchSchema>;
